import React, { ChangeEvent, useContext, useEffect } from "react";
import { useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Select from 'react-select';
import { Button, Modal, Snackbar, TextField, Typography } from "@mui/material";
import { TableFooter, TablePagination } from "@mui/material";
import { TableBody, TableHead } from "@mui/material";
import { TableContainer, TableCell, TableRow } from "@mui/material";
import { Box, Paper, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { del, get, post } from "../../../Services/tokenConfig";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableHead, } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { func_print } from "../../../Func_genericas/func_print";
import { ICabecalho4, IPage4, IPage4Observacoes } from "../../../Interfaces/cadernos/caderno4";
import { Alert } from "../../../Components/Alert/Alert";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { desformatarNumero_return_null, formatarNumero_ao_digitar, desformatarNumero } from "../../../Func_genericas/formatar_numero_formato_pt";
import { formatar_numeros_tabela_4 } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/caderno4";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { CabecalhoForm } from "./cabecalho";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, message_apenas_numero } from "../../../Func_genericas/valores_estaticos";
import api from "../../../Services/api";
import { url } from "../../../Func_genericas/hosts";
import { handler_pesquisa } from "../../../Func_genericas/func_pesquisa";
import { loader } from "../../../Func_genericas/loader";
import moment from "moment";
import CreatableSelect from 'react-select/creatable';
import { useLocation } from "react-router-dom";
import { FilterByData } from "../../../Func_genericas/filter_by_data";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(1),
    },

    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);

export default function RegProtFitossanitaria() {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const location = useLocation();

  const is_historico = location.state?.is_historico ?? false;


  const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho4 | undefined>();

  const [error_data, setError_data] = useState<boolean>(false);
  const [error_inimigo, setError_inimigo] = useState<boolean>(false);
  const [error_nome, setError_nome] = useState<boolean>(false);
  const [error_n_autorizacao, setError_n_autorizacao] = useState<boolean>(false);
  const [error_area_tratada, setError_area_tratada] = useState<boolean>(false);
  const [error_volume_aplicacao, setError_volume_aplicacao] = useState<boolean>(false);
  const [error_n_autorizacao_atividade, setError_n_autorizacao_atividade] = useState<boolean>(false);
  const [error_concentracao_dose, setError_concentracao_dose] = useState<boolean>(false);

  const [message, setMessage] = React.useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [openDelete, setOpenDelete] = React.useState<boolean>(false);
  const [openDeleteObs, setOpenDeleteObs] = React.useState<boolean>(false);
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(5);

  const [showNewRow, setShowNewRow] = useState<boolean>(false);
  const [showObsRow, setShowObsRow] = useState<boolean>(false);

  const [rows, setRows] = useState<IPage4[]>([]);
  const [rows_filtrada, setRows_filtrada] = useState<IPage4[]>([]);
  const [newRow, setNewRow] = useState<IPage4 | undefined>();

  const [lista_prods_to_select, set_lista_prods_to_select] = useState<any[]>([]);
  const [lista_prods_to_select_aux, set_lista_prods_to_select_aux] = useState<any[]>([]);
  const [rowsObs, setRowsObs] = useState<IPage4Observacoes[]>([]);
  const [rowObs, setRowObs] = useState<IPage4Observacoes | undefined>();

  const camposNumericos = ["volume_aplicacao", "area_tratada", "n_autorizacao_atividade"];
  const [flag_editado, set_flag_editado] = React.useState<boolean>(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState<boolean>(false);
  const [flag_open_modal_aviso_datas_sifito, set_flag_open_modal_aviso_datas_sifito] = React.useState<boolean>(false);
  const [prod_to_select_aux, set_prod_to_select_aux] = useState<any>();





  const handle_produtos = async () => {
    try {
      setIsLoading(true);
      let res = await api.get(url + 'sifito');

      let aux_list = res.data.Data.map((el: any) => {
        return {
          value: el.NumAutProd,
          label: el.DesignCom,
          obj: el,
          descrit: el.descrit
        }
      })

      set_lista_prods_to_select(aux_list)
      set_lista_prods_to_select_aux(aux_list)
      setIsLoading(false);

    } catch (error) {
      func_print("handle_produtos", error, true);
      setIsLoading(false);
    }


  }


  const handleCloseDialog = () => {
    handleCancel()

    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  //GET
  const getFitossanitaria = async () => {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_fitossanitaria_cabecalho/${obj_anexo_cabecalho_selecionado?.id_registo_fitocabe}`);
      if (res.status === 200) {

        const formattedData = res.data.result.map(formatar_numeros_tabela_4);
        setRows(formattedData);
        setRows_filtrada(formattedData)
      };
      setIsLoading(false);
    } catch (error) {
      func_print("getFitossanitaria", error, true);
      setIsLoading(false);
    }
  }

  const getFitossanitariaObservacoes = async () => {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_fitossanitaria_obs_cabecalho/${obj_anexo_cabecalho_selecionado?.id_registo_fitocabe}`);
      if (res.status === 200) {
        setRowsObs(res.data.result);

      };
      setIsLoading(false);
    } catch (error) {
      func_print("getFitossanitariaObservacoes", error, true);
      // setMessage("Erro ao efetuar a sua operação!");
      // setOpenSnackError(true);
      setIsLoading(false);
    }
  }

  useEffect(() => {

    (async () => {
      if (obj_anexo_cabecalho_selecionado !== undefined) {
        await getFitossanitaria();
        await getFitossanitariaObservacoes();
        await handle_produtos()

        setNewRow((tab: any) => ({
          ...tab,
          id_registo_fitocabe: obj_anexo_cabecalho_selecionado.id_registo_fitocabe
        }))
      } else {
        setIsLoading(false)
      }
    })();
  }, [obj_anexo_cabecalho_selecionado]);

  const handleCancel = () => {
    setShowNewRow(false);
    setShowObsRow(false);
    setNewRow(undefined);
    setRowObs(undefined)
    setError_data(false);
    setError_inimigo(false);
    setError_n_autorizacao(false);
    setError_volume_aplicacao(false);
    setError_area_tratada(false);
    setError_nome(false);
    setError_concentracao_dose(false);
    setError_n_autorizacao_atividade(false);
    set_prod_to_select_aux(undefined)
    set_lista_prods_to_select_aux(lista_prods_to_select)

  }

  /****************************** PAGINA FITOSSANITÁRIO **********************************************/
  const onInputChangeFitossanitaria = (event: any) => {
    const target = event.target as HTMLInputElement | HTMLSelectElement;
    const { name, value, } = target;
    set_flag_editado(true)

    if (name === "data") {
      if (value === "" || value === undefined) {
        setError_data(true);
      } else {
        setError_data(false);
      }
    } else if (name === "inimigo") {
      if (value.trim() === "" || value === undefined) {
        setError_inimigo(true);
      } else {
        setError_inimigo(false);
      }
    } else if (name === "nome") {
      if (value.trim() === "" || value === undefined) {
        setError_nome(true);
      } else {
        setError_nome(false);
      }
    } else if (name === "n_autorizacao_atividade") {
      if (value.trim() === "" || value === undefined) {
        setError_n_autorizacao_atividade(true);
      } else {
        setError_n_autorizacao_atividade(false);
      }
    } else if (name === "n_autorizacao") {
      if (value.trim() === "" || value === undefined) {
        setError_n_autorizacao(true);
      } else {
        setError_n_autorizacao(false);
      }
    } else if (name === "concentracao_dose") {
      if (value.trim() === "" || value === undefined) {
        setError_concentracao_dose(true);
      } else {
        setError_concentracao_dose(false);
      }
    }
    const isCampoNumerico = camposNumericos.includes(name);

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));
      const updatedValues: any = { [name]: valorSemFormatar };

      if (!isNaN(valorNumerico)) {
        updatedValues[name] = formatarNumero_ao_digitar(valorSemFormatar);

        if (name === "area_tratada") {
          setError_area_tratada(false);
        } else if (name === "volume_aplicacao") {
          setError_volume_aplicacao(false);
        } else if (name === "n_autorizacao_atividade") {
          setError_n_autorizacao_atividade(false);
        } else if (name === "concentracao_dose") {
          setError_concentracao_dose(false);
        }
      } else {
        if (name === "area_tratada") {
          setError_area_tratada(true);
        } else if (name === "volume_aplicacao") {
          setError_volume_aplicacao(true);
        } else if (name === "n_autorizacao_atividade") {
          setError_n_autorizacao_atividade(true);
        } else if (name === "concentracao_dose") {
          setError_concentracao_dose(true);
        }
      }
      setNewRow((prevnewRow: any) => ({
        ...prevnewRow,
        ...updatedValues,
      }));
    } else {

      if (name === "inimigo") {


        let lista_aux = handler_pesquisa(lista_prods_to_select, ['descrit'], value)

        set_lista_prods_to_select_aux(lista_aux)
      }
      setNewRow((prevnewRow: any) => ({
        ...prevnewRow,
        [name]: value
      }));
    }
  }
  const passouDataLimUtil = () => {
    if (!newRow?.data) return true;

    const dataRow = moment(newRow.data);
    const dataLimUtil = moment(prod_to_select_aux.DataLimUtil);

    return dataRow.isAfter(dataLimUtil);
  }
  const handleSaveFito = async () => {
    if (newRow?.data === "" || newRow?.data === undefined) {
      setError_data(true)
    } if (prod_to_select_aux !== undefined && passouDataLimUtil()) {

      // mostar erro
      set_flag_open_modal_aviso_datas_sifito(true)


    } else {
      if (
        newRow?.data === undefined || newRow?.data === "" ||
        newRow?.inimigo === undefined || newRow?.inimigo === "" ||
        newRow?.n_autorizacao === undefined || newRow?.n_autorizacao === "" ||
        newRow?.concentracao_dose === undefined || newRow?.concentracao_dose === "" ||
        newRow?.volume_aplicacao === undefined || newRow?.volume_aplicacao === "" ||
        newRow?.area_tratada === undefined || newRow?.area_tratada === "" ||
        newRow?.nome === undefined || newRow?.nome === "" ||
        newRow?.n_autorizacao_atividade === undefined || newRow?.n_autorizacao_atividade === ""
      ) {
        if (newRow?.data === "" || newRow?.data === undefined) {
          setError_data(true);
        }
        if (newRow?.inimigo === "" || newRow?.inimigo === undefined) {
          setError_inimigo(true);
        }
        if (newRow?.n_autorizacao === "" || newRow?.n_autorizacao === undefined) {
          setError_n_autorizacao(true);
        }

        if (newRow?.volume_aplicacao === "" || newRow?.volume_aplicacao === undefined) {
          setError_volume_aplicacao(true);
        }
        if (newRow?.area_tratada === "" || newRow?.area_tratada === undefined) {
          setError_area_tratada(true);
        }
        if (newRow?.nome === "" || newRow?.nome === undefined) {
          setError_nome(true);
        }
        if (newRow?.n_autorizacao_atividade === "" || newRow?.n_autorizacao_atividade === undefined) {
          setError_n_autorizacao_atividade(true);
        }
        if (newRow?.concentracao_dose === "" || newRow?.concentracao_dose === undefined) {
          setError_concentracao_dose(true);
        }
        setMessage("Preencha todos os campos obrigatórios!");
        setOpenSnackError(true);
      } else {

        try {
          setIsLoading(true);

          let res = await post(auth.token.cookie_token, "/new_reg_fitossanitaria", {
            payload: {
              id_registo_fito: 0,
              data: newRow?.data === undefined ? null : newRow?.data,
              estado_fenologico: newRow?.estado_fenologico === undefined ? null : newRow?.estado_fenologico,
              inimigo: newRow?.inimigo === undefined ? null : newRow?.inimigo,
              metodologia: newRow?.metodologia === undefined ? null : newRow?.metodologia,
              estimativa_risco: newRow?.estimativa_risco === undefined ? null : newRow?.estimativa_risco,
              justifi_intervencao: newRow?.justifi_intervencao === undefined ? null : newRow?.justifi_intervencao,
              observacoes_aux: newRow?.observacoes_aux === undefined ? null : newRow?.observacoes_aux,
              n_autorizacao: newRow?.n_autorizacao === undefined ? null : newRow?.n_autorizacao,
              nome_biocida: newRow?.nome_biocida === undefined ? null : newRow?.nome_biocida,
              concentracao_dose: newRow?.concentracao_dose === undefined ? null : newRow?.concentracao_dose,
              volume_aplicacao: newRow?.volume_aplicacao === undefined ? null : desformatarNumero(newRow?.volume_aplicacao),
              intervalo_seguranca: newRow?.intervalo_seguranca === undefined ? null : newRow?.intervalo_seguranca,
              area_tratada: newRow?.area_tratada === undefined ? null : desformatarNumero(newRow?.area_tratada),
              n_aplicador: newRow?.n_aplicador === undefined ? null : newRow?.n_aplicador,
              nome: newRow?.nome === undefined ? null : newRow?.nome,
              n_autorizacao_atividade: newRow?.n_autorizacao_atividade === undefined ? null : newRow?.n_autorizacao_atividade,
              id_registo_fitocabe: obj_anexo_cabecalho_selecionado?.id_registo_fitocabe,
              last_update: new Date().toISOString(),
              create_date: new Date().toISOString(),
              uuid: "",
            }
          });
          if (res.status === 200) {
            setError_data(false);
            setError_inimigo(false);
            setError_n_autorizacao(false);
            setError_volume_aplicacao(false);
            setError_area_tratada(false);
            setError_nome(false);
            setError_concentracao_dose(false);

            setError_n_autorizacao_atividade(false);
            set_flag_editado(false)
            set_prod_to_select_aux(undefined)
            set_lista_prods_to_select_aux(lista_prods_to_select)

            setMessage("Gravado com sucesso!");
            setOpenSnackSuccess(true);
            setShowNewRow(false);

            setNewRow(undefined);

            setRows((prevRows) => {
              if (prevRows !== undefined) {
                return [...prevRows, formatar_numeros_tabela_4(res.data.result)]
              } else {
                return [formatar_numeros_tabela_4(res.data.result)]
              }
            }
            )
            setRows_filtrada((prevRows) => {
              if (prevRows !== undefined) {
                return [...prevRows, formatar_numeros_tabela_4(res.data.result)]
              } else {
                return [formatar_numeros_tabela_4(res.data.result)]
              }
            }
            )


          } else {
            setMessage("Erro ao gravar!");
            setOpenSnackError(true);
          }
          setIsLoading(false);
        } catch (error: any) {
          func_print("handleSaveFito", error, true);
          if (error?.status === 409) {

            setMessage(error?.response.data.detail);
            setOpenSnackError(true);
          } else {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
          }
          setIsLoading(false);
        }
      }
    }

  };
  // Editar
  const handleEdit = (obj: IPage4) => {
    setNewRow(obj)
  };

  const handleUpdateFitossanitaria = async () => {

    if (prod_to_select_aux !== undefined && passouDataLimUtil()) { /// comparar datas
      // mostar erro
      set_flag_open_modal_aviso_datas_sifito(true)


    } else {
      if (
        newRow?.data === undefined || newRow?.data === "" ||
        newRow?.inimigo === undefined || newRow?.inimigo === "" ||
        newRow?.n_autorizacao === undefined || newRow?.n_autorizacao === "" ||
        newRow?.concentracao_dose === undefined || newRow?.concentracao_dose === "" ||
        newRow?.volume_aplicacao === undefined || newRow?.volume_aplicacao === "" ||
        newRow?.area_tratada === undefined || newRow?.area_tratada === "" ||
        newRow?.nome === undefined || newRow?.nome === "" ||
        newRow?.n_autorizacao_atividade === undefined || newRow?.n_autorizacao_atividade === ""
      ) {
        if (newRow?.data === "" || newRow?.data === undefined) {
          setError_data(true);
        }
        if (newRow?.inimigo === "" || newRow?.inimigo === undefined) {
          setError_inimigo(true);
        }
        if (newRow?.n_autorizacao === "" || newRow?.n_autorizacao === undefined) {
          setError_n_autorizacao(true);
        }

        if (newRow?.volume_aplicacao === "" || newRow?.volume_aplicacao === undefined) {
          setError_volume_aplicacao(true);
        }
        if (newRow?.area_tratada === "" || newRow?.area_tratada === undefined) {
          setError_area_tratada(true);
        }
        if (newRow?.nome === "" || newRow?.nome === undefined) {
          setError_nome(true);
        }
        if (newRow?.n_autorizacao_atividade === "" || newRow?.n_autorizacao_atividade === undefined) {
          setError_n_autorizacao_atividade(true);
        }
        if (newRow?.concentracao_dose === "" || newRow?.concentracao_dose === undefined) {
          setError_concentracao_dose(true);
        }
        setMessage("Preencha todos os campos obrigatórios!");
        setOpenSnackError(true);
      } else {
        try {
          setIsLoading(true);

          const res = await post(auth.token.cookie_token, "/update_reg_fitossanitaria", {
            payload: {
              id_registo_fito: newRow?.id_registo_fito,
              data: newRow?.data === undefined ? null : newRow.data,
              estado_fenologico: newRow?.estado_fenologico === undefined ? null : newRow.estado_fenologico,
              inimigo: newRow?.inimigo === undefined ? null : newRow.inimigo,
              metodologia: newRow?.metodologia === undefined ? null : newRow.metodologia,
              estimativa_risco: newRow?.estimativa_risco === undefined ? null : newRow.estimativa_risco,
              justifi_intervencao: newRow?.justifi_intervencao === undefined ? null : newRow.justifi_intervencao,
              observacoes_aux: newRow?.observacoes_aux === undefined ? null : newRow.observacoes_aux,
              n_autorizacao: newRow?.n_autorizacao === undefined ? null : newRow.n_autorizacao,
              nome_biocida: newRow?.nome_biocida === undefined ? null : newRow.nome_biocida,
              concentracao_dose: newRow?.concentracao_dose === undefined ? null : newRow.concentracao_dose,
              volume_aplicacao: newRow?.volume_aplicacao === undefined ? null : desformatarNumero_return_null(newRow.volume_aplicacao),
              intervalo_seguranca: newRow?.intervalo_seguranca === undefined ? null : newRow?.intervalo_seguranca,
              area_tratada: newRow?.area_tratada === undefined ? null : desformatarNumero_return_null(newRow.area_tratada),
              n_aplicador: newRow?.n_aplicador === undefined ? null : newRow.n_aplicador,
              nome: newRow?.nome === undefined ? null : newRow.nome,
              n_autorizacao_atividade: newRow?.n_autorizacao_atividade === undefined ? null : newRow.n_autorizacao_atividade,
              id_registo_fitocabe: obj_anexo_cabecalho_selecionado?.id_registo_fitocabe,
              last_update: newRow?.last_update,
              create_date: newRow?.create_date,
              uuid: newRow?.uuid,
            }
          });
          if (res.status === 200) {
            setMessage("Registado com sucesso!");

            const updatedRows = rows.map((row) => {
              if (row.id_registo_fito === newRow.id_registo_fito) {
                return formatar_numeros_tabela_4(res.data.result)
              } else {
                return row;
              }
            });

            setRows(updatedRows !== undefined ? updatedRows : []);
            setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
            set_flag_editado(false)
            setNewRow(undefined);
            setOpenSnackSuccess(true);
            setError_data(false);
            setError_inimigo(false);
            setError_n_autorizacao(false);
            setError_volume_aplicacao(false);
            setError_area_tratada(false);
            setError_nome(false);
            setError_concentracao_dose(false)
            setError_n_autorizacao_atividade(false);
            set_flag_editado(false)
            set_prod_to_select_aux(undefined)
            set_lista_prods_to_select_aux(lista_prods_to_select)
          } else {
            setMessage("Erro ao gravar!");
            setOpenSnackError(true);
          }
          setIsLoading(false);

        } catch (error: any) {
          func_print("handleUpdate", error, true);
          if (error?.status === 409) {

            setMessage(error?.response.data.detail);
            setOpenSnackError(true);
          } else {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
          }
          setIsLoading(false);
        }
      }
    }
  };
  // Delete
  const handleClickOpenDelete = (obj: IPage4) => {
    setNewRow(obj);
    setOpenDelete(true);
  };
  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_fitossanitaria/${newRow?.id_registo_fito}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDelete(false);
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_fito !== newRow?.id_registo_fito),
        ]);
        setRows_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_fito !== newRow?.id_registo_fito),
        ]);
        setNewRow(undefined);

        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /****************************** CAMPO OBSERVAÇÕES **********************************************/
  const onInputChangeObs = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    set_flag_editado(true)

    setRowObs((prevnewRow: any) => ({
      ...prevnewRow,
      [name]: value,
    }));
  };

  const handleSaveFitossanitariaObs = async () => {
    if (rowObs?.observacoes === "" || rowObs?.observacoes === undefined) {
      setMessage("Preencha o campo Observações antes de gravar!");
      setOpenSnackError(true);
    } else {

      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "/new_reg_fitossanitaria_obs", {
          payload: {
            id_registo_fito_obs: 0,
            observacoes: rowObs?.observacoes === undefined ? null : rowObs.observacoes,
            id_registo_fitocabe: obj_anexo_cabecalho_selecionado?.id_registo_fitocabe,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });
        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);
          setShowObsRow(false);
          set_flag_editado(false)

          setRowObs(undefined);

          setRowsObs((prevRows) => {
            if (prevRows !== undefined) {
              return [...prevRows, res.data.result]
            } else {
              return [res.data.result]
            }
          }
          )
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error: any) {
        func_print("handleSaveFito", error, true);
        // if (error?.status === 409) {

        //   setMessage(error?.response.data.detail);
        //   setOpenSnackError(true);
        // } else {
        //   setMessage("Erro ao efetuar a sua operação!");
        //   setOpenSnackError(true);
        // }

        if ((error as any)?.response?.data?.message) {
          setMessage((error as any).response.data.message);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
        }
        setOpenSnackError(true);

        setIsLoading(false);
      }
    }
  };
  //Editar
  const handleEditObs = (obj: IPage4Observacoes) => {
    setRowObs(obj);
    setShowObsRow(true);
  }

  const handleUpdateObs = async () => {

    try {
      setIsLoading(true);

      const res = await post(auth.token.cookie_token, "/update_reg_fitossanitaria_obs", { payload: rowObs });
      if (res.status === 200) {
        setMessage("Registado com sucesso!");

        const updatedRows = rowsObs.map((row) => {
          if (row.id_registo_fito_obs === rowObs?.id_registo_fito_obs) {
            return res.data.result;
          } else {
            return row;
          }
        });
        set_flag_editado(false)

        setRowsObs(updatedRows !== undefined ? updatedRows : []);
        setShowObsRow(false);
        setRowObs(undefined);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error: any) {
      func_print("handleUpdateObs", error, true);
      if (error?.status === 409) {

        setMessage(error?.response.data.detail);
        setOpenSnackError(true);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    }

  }
  // Delete
  const handleClickOpenDeleteObs = (obj: IPage4Observacoes) => {
    setRowObs(obj);
    setOpenDeleteObs(true);
  };
  const handleDeleteObs = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete__reg_fitossanitaria_obs/${rowObs?.id_registo_fito_obs}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDeleteObs(false);
        setRowObs(undefined);
        setRowsObs((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_fito_obs !== rowObs?.id_registo_fito_obs),
        ]);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDelete", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };


  /**************** PAGINAÇÃO *********************/
  // // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const verificarDatas = (DataLimUtil: any, DataLimCom: any) => {
    if (!newRow?.data) return false;

    const dataRow = moment(newRow?.data);
    const dataLimUtil = moment(DataLimUtil);
    const dataLimCom = moment(DataLimCom);

    // Verifica se está a menos de um mês da DataLimUtil
    const diffEmMeses = dataLimUtil.diff(dataRow, "months", true);
    const aMenosDeUmMes = diffEmMeses < 1 && diffEmMeses >= 0;

    //  Verifica se já passou da DataLimCom
    const passouDataLimCom = dataRow.isAfter(dataLimCom);



    const flag_to_return = aMenosDeUmMes === true ? true : passouDataLimCom === true ? true : false
    return flag_to_return
  }
  return (
    <CustomThemeProvider>
      <Modal
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={flag_open_modal_aviso_datas_sifito}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          width: '40%',
          height: '30%',
          flexDirection: 'column',
          borderRadius: 5,
          backgroundColor: 'white',

        }}>
          <div style={{
            backgroundColor: 'red',

            width: '100%',
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
            flex: 0.1,
          }}>
            <div style={{
              color: "white",
              fontWeight: 'bold',
              display: "flex",
              alignItems: 'center',
              justifyContent: 'center',
              flex: 0.15,

            }}></div>
            <div style={{
              color: "white",
              fontWeight: 'bold',
              display: "flex",
              alignItems: 'center',
              justifyContent: 'center',
              flex: 0.8,

            }}>Alerta data do produto inválida</div>
            <Button
              sx={{
                color: "white",
                fontWeight: 'bold',
                display: "flex",
                alignItems: 'center',
                justifyContent: 'center',
                flex: 0.1,

              }}
              size="large"
              onClick={() => {
                set_flag_open_modal_aviso_datas_sifito(false)
              }}
            >
              <CloseIcon />
            </Button>
          </div>
          <div style={{
            fontWeight: 'bold',
            width: '100%',
            display: "flex",
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 0.1,
            paddingTop: '5%'
          }}>

            {prod_to_select_aux === undefined ? '' : prod_to_select_aux.DesignCom}

          </div>
          <div style={{
            width: '100%',
            display: "flex",
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            flex: 0.7,
          }}>

            <div >

              Data limite de utilização:
              {prod_to_select_aux === undefined ? '' : moment(prod_to_select_aux.DataLimUtil).format('DD-MM-YYYY')}

            </div>
            <div>

              Data limite de comercialização:
              {prod_to_select_aux === undefined ? '' : moment(prod_to_select_aux.DataLimCom).format('DD-MM-YYYY')}

            </div>
          </div>
        </div>

      </Modal>
      <div className={classes.root}>
        <CadernoLayout title="4 - Registo de Proteção Fitossanitária e aplicação de biocidas" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <div>
            <Box width="80%" margin="auto">
              <BeneficiarioNomeIdAlinhadoDireita />
            </Box>

            {/* <FilterByData
              lista_original={rows}
              lista_filtrada={rows_filtrada}
              set_lista_original={setRows}
              set_lista_filtrada={setRows_filtrada}
              campoData={"data"}

            /> */}
            <FilterByData
              listas={[
                {
                  lista_original: rows,
                  set_lista_filtrada: setRows_filtrada,
                  campoData: "data",
                },
               
              ]}
            />


            <Snackbar
              open={openSnackSuccess}
              autoHideDuration={2000}
              onClose={() => setOpenSnackSuccess(false)}
            >
              <Alert
                onClose={() => setOpenSnackSuccess(false)}
                severity="success"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
            <Snackbar
              open={openSnackError}
              autoHideDuration={2000}
              onClose={() => setOpenSnackError(false)}
            >
              <Alert
                onClose={() => setOpenSnackError(false)}
                severity="error"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>

            <Box style={{ width: "100%", height: "auto" }}>
              <CabecalhoForm
                obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
                set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
              />
            </Box>

            {isLoading ? (
              <LoadingVulpes />
            ) : (
              obj_anexo_cabecalho_selecionado !== undefined ?
                <TableContainer
                  component={Paper}
                  variant="outlined"
                  sx={{ height: "auto", width: "auto", margin: 2, padding: 2, }} >
                  <table style={{ width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={16}>
                          <Box sx={{ display: "flex", justifyContent: "end", }} >
                            {is_historico === true ? <></> :
                              <BarraDeFerramentas
                                mostrarBotaoNovo
                                textoBotaoNovo="Novo Registo"
                                aoClicarNovo={() => {
                                  handleCancel();
                                  setShowNewRow(true)
                                }}
                              />}
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead rowSpan={3}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Data*
                            <BasicPopover text={"Data deve ser registada no formato dd-mm-aaaa"} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={3} sx={{ minWidth: 120 }}>
                          Estado
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            fenológico
                            <BasicPopover text={"Estado fenológico da cultura deve ser registado por zona homogénea."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={3} sx={{ minWidth: 120 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Inimigo*
                            <BasicPopover text={"Nome da praga, doença, infestante ou grupo de infestantes.\n\nCampo de preenchimento obrigatório para cumprimento da exigência de manutenção de registo estabelecida no indicador 1.4, da área 1, RLG 5, Anexo III, Portaria n.º 54-Q/2023. Em alternativa, o referido diploma prevê a hipótese de o beneficiário indicar o 'efeito a atingir', que no presente modelo é possível preenchendo o campo «justificação da intervenção»."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={3} sx={{ minWidth: 150 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Metodologia
                            <BasicPopover text={"Metodologia utilizada: observação visual/tipo de armadilha."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={3} sx={{ minWidth: 150 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Estimativa do risco e/ou NEA
                            <BasicPopover text={"NEA - Nível Económico de Ataque. 'Estimativa do risco/NEA' – Registos que levam à tomada de decisão da eventual realização dos tratamentos fitossanitários. Quantificação/resultado obtido da estimativa do risco."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={3} sx={{ minWidth: 180 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Justificação da intervenção
                            <BasicPopover text={"A justificação da intervenção, sempre que possível, deve incluir as condições climáticas que levaram ao tratamento fitossanitário. \n\n Para cumprimento da exigência de manutenção de registo estabelecida no indicador 1.4, da área 1, RLG 5, Anexo III, Portaria n.º 54-Q/2023, o beneficiário poderá indicar o efeito a atingir com a aplicação de produto fitofarmacêutico no presente campo em alternativa ao preenchimento do campo «inimigo»."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={3} sx={{ minWidth: 150 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Observação / Largada de auxiliares
                            <BasicPopover text={"Observação de presença de auxiliares ou largada de auxiliares (sobretudo em estufa) espécies e quantidades."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead colSpan={7}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Tratamento fitossanitário/Aplicação biocida
                            <BasicPopover text={" Todos os aplicadores devem efetuar e manter, durante pelo menos três anos, o registo de quaisquer tratamentos efetuados \n com produtos fitofarmacêuticos em território nacional, designadamente como anexo ao caderno de campo,\n  incluindo, nomeadamente, a referência ao nome comercial e ao número de autorização de venda do produto, \no nome e número de autorização de exercício de atividade do estabelecimento de venda onde o produto foi adquirido,\n a data e a dose ou concentração e volume de calda da aplicação, a área, \nculturas e respetivo inimigo, ou outra finalidade para que o produto foi utilizado."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead colSpan={2} sx={{ minWidth: 250 }}>
                          Estabelecimento de venda onde o produto
                          fitofarmaceutico foi adquirido
                        </StyledTableHead>
                        <StyledTableHead rowSpan={3}>Ações</StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead sx={{ minWidth: 200 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Nº de autorização*
                            <BasicPopover text={"De acordo com os casos aplicáveis preencher com: \n - Autorização Provisória de venda (APV); \n- Autorização de Venda (AV); \n - Autorização de Comércio Paralelo (ACP); \n - Autorização Excecional de Emergência (AEE). \n\n  Condicionalidade: campo de preenchimento obrigatório para efeito do cumprimento do indicador 1.4, da área 1, do RLG 5"} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Nome de S.A/Biocida/Subs. de base
                            <BasicPopover text={"SA – Substância Ativa do produto firofarmacêutico aplicado. \nNo caso de aplicação de biocida registar qual o biocida utilizado. \nSubstância de base - Consideram-se as substâncias de base aprovadas a nível comunitário para utilização na proteção fitossanitária das culturas, nos termos do Regulamento (CE) nº 1107/2009 de 21 de outubro. \nDeve ser preenchida com um dos seguintes valores: \n - Equisetum arvense;\n - Cloridrato de quitosano;\n- Hidróxido de cálcio; \n- Lecitina;\n - Salix spp. cortex;\n - Vinagre;\n - Frutose;\n - Hidrogenocarbonato de sódio;\n - Fosfato diamónico;\n - Soro de leite;\n - Óleo de girassol;\n - Peróxido de hidrogénio;\n - Urtica spp.;\n - Carvão vegetal com bentonite;\n - Cloreto de sódio; \n - Pó de sementes de mostarda;\n - Cerveja; \n - Talco E553B; \n - Óleo de cebola; \n - L-cisteína (E 920); \n- Leite de vaca; \n- Extrato de Bolbo de Allium cepa L.; \n- Quitosano"} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 180 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Quantidade de produto aplicado (kg ou Litros de produto comercial*)
                            <BasicPopover text={"Condicionalidade: campo de preenchimento obrigatório para efeitos dos indicadores 1.4 e 1.5, da área 1 do RLG 5 da portaria n.º 54-Q/2023."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Volume de calda da aplicação*
                            <BasicPopover text={"Condicionalidade: campo de preenchimento  obrigatório para efeito do cumprimento do indicador 1.4, da área 1, do RLG 5 da Portaria n.º 54-Q/2023."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 150 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Intervalo de Segurança
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 100 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Área tratada (ha)*
                            <BasicPopover text={"A área tratada deve ser expressa em hectares, no caso de aplicações de produtos fitofarmacêuticos sobre culturas ou em m2, no caso de tratamentos em instalações com produtos fitofarmacêuticos ou biocidas.\n\n Condicionalidade: campo de preenchimento  obrigatório para efeito do cumprimento do indicador 1.4, da área 1, do RLG 5 da Portaria n.º 54-Q/2023."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            N.º de aplicador
                            <BasicPopover text={"Número de identificação do (ou dos) aplicadores dos PF's."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Nome*
                            <BasicPopover text={"Condicionalidade: campo de preenchimento  obrigatório para efeito do cumprimento do indicador 1.4, da área 1, do RLG 5 da Portaria n.º 54-Q/2023."} />
                          </Stack>
                        </StyledTableHead>
                        <StyledTableHead rowSpan={2} sx={{ minWidth: 120 }}>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            N.º de autorização de exercício de atividade*
                            <BasicPopover text={"Condicionalidade: campo de preenchimento  obrigatório para efeito do cumprimento do indicador 1.4, da área 1, do RLG 5 da Portaria n.º 54-Q/2023."} />
                          </Stack>
                        </StyledTableHead>
                      </TableRow>
                      <TableRow>
                        <StyledTableHead>
                          <Stack direction="row" justifyContent="center" alignItems="center">
                            Nome Comercial
                            <BasicPopover text={"Condicionalidade: campo de preenchimento  obrigatório para efeito do cumprimento do indicador 1.4, da área 1, do RLG 5 da Portaria n.º 54-Q/2023."} />
                          </Stack>
                        </StyledTableHead>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {showNewRow && (
                        <TableRow>
                          <StyledTableCell>
                            <TextField
                              variant="filled"
                              name="data"
                              type="date"

                              value={newRow?.data === undefined ? "" : newRow.data}
                              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                                onInputChangeFitossanitaria(e)}
                            />
                            {error_data && (
                              <p style={{ color: "#c90606", fontSize: "11px" }}>
                                Preencha este campo
                              </p>
                            )}
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="estado_fenologico"
                              value={newRow?.estado_fenologico === undefined ? "" : newRow.estado_fenologico}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="inimigo"
                              value={newRow?.inimigo === undefined ? "" : newRow.inimigo}
                              onChange={onInputChangeFitossanitaria}
                              error={error_inimigo}
                              helperText={error_inimigo ? "Preencha este campo" : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="metodologia"
                              value={newRow?.metodologia === undefined ? "" : newRow.metodologia}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="estimativa_risco"
                              value={newRow?.estimativa_risco === undefined ? "" : newRow.estimativa_risco}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="justifi_intervencao"
                              value={newRow?.justifi_intervencao === undefined ? "" : newRow.justifi_intervencao}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="observacoes_aux"
                              value={newRow?.observacoes_aux === undefined ? "" : newRow.observacoes_aux}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            {/* <CustomTextField
                              name="n_autorizacao"
                              value={newRow?.n_autorizacao}
                              onChange={onInputChangeFitossanitaria}
                              error={error_n_autorizacao}
                              helperText={error_n_autorizacao ? "Preencha este campo" : ""}
                            /> */}
                            <CreatableSelect
                              formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}

                              placeholder={'Selecionar'}
                              components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                              noOptionsMessage={() => "Não encontrado"}
                              menuPosition="absolute"
                              menuShouldScrollIntoView={false}
                              styles={{
                                menuPortal: base => ({
                                  ...base,
                                  fontSize: 14
                                }),

                                option: (styles, state) => ({
                                  ...styles,
                                  color: state.isSelected ? 'white' : 'black',
                                  fontSize: 14,
                                  backgroundColor: state.isSelected ? cores.cor1 : 'white',
                                  '&:hover': {
                                    backgroundColor: cores.cor3,
                                    color: 'white',
                                  }

                                }),

                                control: base => ({
                                  ...base,
                                  fontSize: 14,

                                  height: 50,
                                  minHeight: 10,
                                  width: 200,
                                  alignItems: 'center',
                                  paddingTop: 0,
                                  marginTop: 0,
                                  boxShadow: 'none',
                                  border: `1px solid silver`,
                                  '&:hover': {
                                    border: '1px solid silver',
                                  }
                                }),

                                input: (provided, state) => ({
                                  ...provided,
                                  fontSize: 14,
                                  paddingTop: 0,
                                  marginTop: 0,

                                }),

                              }}
                              onChange={(e: any) => {

                                // console.log('e', e)
                                if (e.label === e.value) {
                                  setNewRow((prevnewRow: any) => ({
                                    ...prevnewRow,
                                    ['n_autorizacao']: e.label,
                                  }));
                                  set_prod_to_select_aux(undefined)

                                } else {

                                  set_prod_to_select_aux(e.obj)


                                  setNewRow((prevnewRow: any) => ({
                                    ...prevnewRow,
                                    ['n_autorizacao']: e.label,
                                    ['nome_biocida']: e.obj.SaSin,
                                    ['concentracao_dose']: e.obj.Teores,
                                  }));

                                  if (verificarDatas(e.obj.DataLimUtil, e.obj.DataLimCom)) {
                                    set_flag_open_modal_aviso_datas_sifito(true)
                                  }
                                }

                              }}
                              options={lista_prods_to_select_aux}
                            />
                          </StyledTableCell>
                          <StyledTableCell>

                            <CustomTextField
                              name="nome_biocida"
                              value={newRow?.nome_biocida !== undefined ? newRow.nome_biocida : ""}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" alignItems="center" >
                              <CustomTextField
                                name="concentracao_dose"
                                value={newRow?.concentracao_dose === undefined ? "" : newRow.concentracao_dose}
                                onChange={onInputChangeFitossanitaria}
                                error={error_concentracao_dose}
                                helperText={error_concentracao_dose ? message_apenas_numero : ""}

                              />

                            </Stack>
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="volume_aplicacao"
                              value={newRow?.volume_aplicacao === undefined ? "" : newRow.volume_aplicacao}
                              onChange={onInputChangeFitossanitaria}
                              error={error_volume_aplicacao}
                              helperText={error_volume_aplicacao ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="intervalo_seguranca"
                              value={newRow?.intervalo_seguranca === undefined ? "" : newRow.intervalo_seguranca}
                              onChange={onInputChangeFitossanitaria}

                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              error={error_area_tratada}
                              helperText={error_area_tratada ? message_apenas_numero : ""}
                              name="area_tratada"
                              value={newRow?.area_tratada === undefined ? "" : newRow?.area_tratada}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="n_aplicador"
                              value={newRow?.n_aplicador === undefined ? "" : newRow?.n_aplicador}
                              onChange={onInputChangeFitossanitaria}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="nome"
                              value={newRow?.nome === undefined ? "" : newRow.nome}
                              onChange={onInputChangeFitossanitaria}
                              error={error_nome}
                              helperText={error_nome ? "Preencha este campo" : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <CustomTextField
                              name="n_autorizacao_atividade"
                              value={newRow?.n_autorizacao_atividade === undefined ? "" : newRow.n_autorizacao_atividade}
                              onChange={onInputChangeFitossanitaria}
                              error={error_n_autorizacao_atividade}
                              helperText={error_n_autorizacao_atividade ? message_apenas_numero : ""}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <Stack direction="row" justifyContent="center">
                              <ButtonCadernos
                                mostrarBotaoCancelar
                                aoClicarCancelar={() => {
                                  if (flag_editado) {
                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                  } else {
                                    handleCancel()
                                  }
                                }}
                                mostrarBotaoGravar
                                aoClicarGravar={() => handleSaveFito()}
                              />
                            </Stack>
                          </StyledTableCell>
                        </TableRow>
                      )}
                      {(rowsPerPage > 0
                        ? rows_filtrada &&
                        rows_filtrada.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        : rows_filtrada
                      ).sort((a, b) => {
                        const dataA = a.data ? new Date(a.data).getTime() : 0;
                        const dataB = b.data ? new Date(b.data).getTime() : 0;

                        return dataA - dataB; // mais antiga -> mais recente
                      }).map((row, key) => {
                        return (
                          <TableRow key={key}>
                            {newRow?.id_registo_fito === row.id_registo_fito ? (
                              <>
                                <StyledTableCell>
                                  <TextField
                                    variant="filled"
                                    name="data"
                                    type="date"
                                    value={newRow?.data}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => onInputChangeFitossanitaria(e)
                                    }

                                  />
                                  {error_data && (
                                    <p style={{ color: "#c90606", fontSize: "11px" }}>
                                      Preencha este campo
                                    </p>
                                  )}

                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="estado_fenologico"
                                    value={newRow?.estado_fenologico}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="inimigo"
                                    value={newRow?.inimigo}
                                    onChange={onInputChangeFitossanitaria}
                                    error={error_inimigo}
                                    helperText={error_inimigo ? "Preencha este campo" : ""}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="metodologia"
                                    value={newRow?.metodologia}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="estimativa_risco"
                                    value={newRow?.estimativa_risco}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="justifi_intervencao"
                                    value={newRow?.justifi_intervencao}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="observacoes_aux"
                                    value={newRow?.observacoes_aux}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  {/* <CustomTextField
                                    name="n_autorizacao"
                                    value={newRow?.n_autorizacao}
                                    onChange={onInputChangeFitossanitaria}
                                    error={error_n_autorizacao}
                                    helperText={error_n_autorizacao ? "Preencha este campo" : ""}
                                  /> */}

                                  <CreatableSelect
                                    // formatCreateLabel={(inputValue) =>
                                    //   `Criar "${inputValue}"`
                                    // }
                                    // promptTextCreator={(label) => `Criar "${label}"`}
                                    formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}

                                    placeholder={'Selecionar'}
                                    components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
                                    noOptionsMessage={() => "Não encontrado"}
                                    menuPosition="absolute"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                      menuPortal: base => ({
                                        ...base,
                                        fontSize: 14
                                      }),

                                      option: (styles, state) => ({
                                        ...styles,
                                        color: state.isSelected ? 'white' : 'black',
                                        fontSize: 14,
                                        backgroundColor: state.isSelected ? cores.cor1 : 'white',
                                        '&:hover': {
                                          backgroundColor: cores.cor3,
                                          color: 'white',
                                        }

                                      }),

                                      control: base => ({
                                        ...base,
                                        fontSize: 14,

                                        height: 50,
                                        minHeight: 10,
                                        width: 200,
                                        alignItems: 'center',
                                        paddingTop: 0,
                                        marginTop: 0,
                                        boxShadow: 'none',
                                        border: `1px solid silver`,
                                        '&:hover': {
                                          border: '1px solid silver',
                                        }
                                      }),

                                      input: (provided, state) => ({
                                        ...provided,
                                        fontSize: 14,
                                        paddingTop: 0,
                                        marginTop: 0,

                                      }),

                                    }}
                                    onChange={(e: any) => {
                                      if (e.label === e.value) {
                                        setNewRow((prevnewRow: any) => ({
                                          ...prevnewRow,
                                          ['n_autorizacao']: e.label,
                                        }));
                                        set_prod_to_select_aux(undefined)

                                      } else {
                                        set_prod_to_select_aux(e.obj)

                                        setNewRow((prevnewRow: any) => ({
                                          ...prevnewRow,
                                          ['n_autorizacao']: e.label,
                                          ['nome_biocida']: e.obj.SaSin,
                                          ['concentracao_dose']: e.obj.Teores,
                                        }));
                                        if (verificarDatas(e.obj.DataLimUtil, e.obj.DataLimCom)) {
                                          set_flag_open_modal_aviso_datas_sifito(true)
                                        }
                                      }
                                    }}
                                    options={lista_prods_to_select_aux}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="nome_biocida"
                                    value={newRow?.nome_biocida !== undefined ? newRow.nome_biocida : ""}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <Stack direction="row" alignItems="center">
                                    <CustomTextField
                                      name="concentracao_dose"
                                      value={newRow?.concentracao_dose}
                                      onChange={onInputChangeFitossanitaria}
                                    />

                                  </Stack>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="volume_aplicacao"
                                    value={newRow?.volume_aplicacao}
                                    onChange={onInputChangeFitossanitaria}
                                    error={error_volume_aplicacao}
                                    helperText={error_volume_aplicacao ? message_apenas_numero : ""}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="intervalo_seguranca"
                                    value={newRow?.intervalo_seguranca}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="area_tratada"
                                    value={newRow?.area_tratada}
                                    onChange={onInputChangeFitossanitaria}
                                    error={error_area_tratada}
                                    helperText={error_area_tratada ? message_apenas_numero : ""}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="n_aplicador"
                                    value={newRow?.n_aplicador}
                                    onChange={onInputChangeFitossanitaria}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="nome"
                                    value={newRow?.nome}
                                    onChange={onInputChangeFitossanitaria}
                                    error={error_nome}
                                    helperText={error_nome ? "Preencha este campo" : ""}
                                  />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <CustomTextField
                                    name="n_autorizacao_atividade"
                                    value={newRow?.n_autorizacao_atividade}
                                    onChange={onInputChangeFitossanitaria}
                                    error={error_n_autorizacao_atividade}
                                    helperText={error_n_autorizacao_atividade ? message_apenas_numero : ""}
                                  />
                                </StyledTableCell>
                              </>
                            ) : (
                              <>
                                <StyledTableCell>{row.data} </StyledTableCell>
                                <StyledTableCell>{row.estado_fenologico}</StyledTableCell>
                                <StyledTableCell> {row.inimigo} </StyledTableCell>
                                <StyledTableCell> {row.metodologia} </StyledTableCell>
                                <StyledTableCell>{row.estimativa_risco}</StyledTableCell>
                                <StyledTableCell>{row.justifi_intervencao} </StyledTableCell>
                                <StyledTableCell>{row.observacoes_aux} </StyledTableCell>
                                <StyledTableCell>{row.n_autorizacao}</StyledTableCell>
                                <StyledTableCell>{row.nome_biocida}</StyledTableCell>
                                <StyledTableCell> {row.concentracao_dose} </StyledTableCell>
                                <StyledTableCell>{row.volume_aplicacao}</StyledTableCell>
                                <StyledTableCell>{row.intervalo_seguranca}</StyledTableCell>
                                <StyledTableCell>{row.area_tratada}</StyledTableCell>
                                <StyledTableCell> {row.n_aplicador}</StyledTableCell>
                                <StyledTableCell>{row.nome} </StyledTableCell>
                                <StyledTableCell>{row.n_autorizacao_atividade}</StyledTableCell>
                              </>
                            )}
                            {newRow?.id_registo_fito === row.id_registo_fito ? (
                              <StyledTableCell>
                                <ButtonCadernos
                                  mostrarBotaoGravar
                                  aoClicarGravar={handleUpdateFitossanitaria}
                                  mostrarBotaoCancelar
                                  aoClicarCancelar={() => {
                                    if (flag_editado) {
                                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                    } else {
                                      handleCancel()
                                    }
                                  }}
                                />
                              </StyledTableCell>
                            ) : (
                              <StyledTableCell>

                                {
                                  is_historico === true ? <></> :
                                    <ButtonCadernos
                                      mostrarBotaoEditar
                                      aoClicarEditar={() => {
                                        handleCancel();
                                        handleEdit(row)
                                      }}
                                      mostrarBotaoApagar
                                      aoClicarApagar={() => handleClickOpenDelete(row)}
                                    />}
                              </StyledTableCell>
                            )}
                          </TableRow>
                        );
                      })}


                      {rowsObs.length <= 0 ? (
                        showObsRow ?
                          <TableRow>
                            <StyledTableHead>Observações</StyledTableHead>
                            <StyledTableCell colSpan={15}>
                              <CustomTextField
                                name="observacoes"
                                value={rowObs?.observacoes === undefined ? "" : rowObs.observacoes}
                                onChange={onInputChangeObs}
                              />
                            </StyledTableCell>
                            <StyledTableCell>
                              <Stack direction="row" justifyContent="center">
                                <ButtonCadernos
                                  mostrarBotaoCancelar
                                  aoClicarCancelar={() => {
                                    if (flag_editado) {
                                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                    } else {
                                      handleCancel()
                                    }
                                  }}
                                  mostrarBotaoGravar
                                  aoClicarGravar={() => handleSaveFitossanitariaObs()}
                                />
                              </Stack>
                            </StyledTableCell>
                          </TableRow>
                          :
                          <TableRow>
                            <StyledTableHead>Observações</StyledTableHead>
                            <StyledTableCell colSpan={15}></StyledTableCell>
                            <TableCell colSpan={16}>
                              <Box sx={{ display: "flex", justifyContent: "end", }} >
                                {is_historico === true ? <></> :
                                  <BarraDeFerramentas
                                    mostrarBotaoNovo
                                    textoBotaoNovo="Registar Observações"
                                    aoClicarNovo={() => {
                                      handleCancel();
                                      setShowObsRow(true)
                                    }}
                                  />}
                              </Box>
                            </TableCell>
                          </TableRow>
                      )
                        :
                        (rowsObs.map((obs, key) =>
                          <TableRow key={key}>
                            {rowObs?.id_registo_fito_obs === obs.id_registo_fito_obs ? (
                              <>
                                <StyledTableHead>Observações</StyledTableHead>
                                <StyledTableCell colSpan={15}>
                                  <CustomTextField
                                    name="observacoes"
                                    value={rowObs?.observacoes === undefined ? "" : rowObs.observacoes}

                                    onChange={onInputChangeObs}
                                  />
                                </StyledTableCell>
                              </>
                            ) : (
                              <>
                                <StyledTableHead>Observações</StyledTableHead>
                                <StyledTableCell colSpan={15} style={{ textAlign: "left" }}> {obs.observacoes}</StyledTableCell>
                              </>
                            )}
                            {showObsRow ? (
                              <StyledTableCell>
                                <ButtonCadernos
                                  mostrarBotaoGravar
                                  aoClicarGravar={handleUpdateObs}
                                  mostrarBotaoCancelar
                                  aoClicarCancelar={() => {
                                    if (flag_editado) {
                                      set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                    } else {
                                      handleCancel()
                                    }
                                  }}
                                />
                              </StyledTableCell>
                            ) : (
                              <StyledTableCell>

                                {
                                  is_historico === true ? <></> :
                                    <ButtonCadernos
                                      mostrarBotaoEditar
                                      aoClicarEditar={() => {
                                        handleCancel();
                                        handleEditObs(obs)
                                      }}
                                      mostrarBotaoApagar
                                      aoClicarApagar={() => handleClickOpenDeleteObs(obs)}
                                    />}
                              </StyledTableCell>
                            )}
                          </TableRow>
                        )
                        )}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={19} />
                        </TableRow>
                      )}

                    </TableBody>
                    <TableFooter>
                      <TableRow sx={{ width: "100%" }}>
                        <TableCell colSpan={6}>
                          <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                            * Campos de preenchimento obrigatório
                          </Typography>
                        </TableCell>
                        <TablePagination
                          rowsPerPageOptions={[
                            5,
                            10,
                            25,
                            { label: "All", value: -1 },
                          ]}
                          colSpan={10}
                          count={rows.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          labelDisplayedRows={({ from, to, count }) => {
                            return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                          }}
                          labelRowsPerPage={'Linhas por página'}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter>
                  </table>
                </TableContainer>
                :
                <></>
            )}
            <ConfirmDialog
              open={openDelete}
              onClose={() => setOpenDelete(false)}
              onConfirm={handleDelete}
              message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
              open={openDeleteObs}
              onClose={() => setOpenDeleteObs(false)}
              onConfirm={handleDeleteObs}
              message="Deseja eliminar o registo?"
            />
            <ConfirmDialog
              open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
              onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
              onConfirm={() => handleCloseDialog()}
              message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
          </div>
        </main>
      </div>
    </CustomThemeProvider>
  );
}


